import { FAIcon} from "@sgi/gravity/FAIcon";
import { Typography } from "@sgi/gravity/Typography";
import { Box, Flex } from "@chakra-ui/react";
import { faEnvelope, faPhone } from "@fortawesome/pro-solid-svg-icons";
import { useResponseProxy } from "../Custom Hooks/useResponseProxy";

export default function Response() {
  const { responseMsg } = useResponseProxy();

  return (
    <Box
      position="relative"
      maxW="64vw"
      overflow="hidden"
      data-testid="response-page-test"
    >
      <Flex
        direction="column"
        maxW="32vw"
        height="100vh"
        mx="auto"
        alignContent="center"
        justifyContent="center"
        p={4}
      >
        <Typography variant="h2">Something went wrong</Typography>
        <Typography variant="body" my={8}>
          {responseMsg}
        </Typography>
        <Typography variant="h2">Customer service</Typography>
        <Typography variant="body" my={8}>
          Please call your Broker or you can reach us at
        </Typography>
        <Flex flexDirection="row" pb={8}>
          <FAIcon icon={faEnvelope} pr={20} size="3xl" />
          sgiinquiries@sgi.sk.ca
        </Flex>
        <Flex flexDirection="row">
          <FAIcon icon={faPhone} pr={20} size="3xl" />
          1-844-TLK-2SGI (1-844-855-2744)
        </Flex>
      </Flex>
    </Box>
  );
}
